import { useEffect, useState } from 'react';

import { fetchOnboardingComparison, OnboardingComparisonData } from '@/services/onboardingComparisonService';
import { errorReporter } from '@/services/errorReportingService';

export const useTrialWelcomeData = () => {
  const [comparisonData, setComparisonData] = useState<OnboardingComparisonData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadComparisonData = async () => {
      try {
        const data = await fetchOnboardingComparison();
        if (isMounted) {
          setComparisonData(data);
        }
      } catch (error) {
        errorReporter.expected('Failed to load onboarding comparison data', error, {
          feature: 'onboarding',
          operation: 'loadComparisonData',
        });
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadComparisonData();

    return () => {
      isMounted = false;
    };
  }, []);

  return { comparisonData, loading };
};
